import './env-setup';
import './styles.scss';
import 'virtual:integro-icons';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { Application, ApplicationSpec } from '@integro/core';
import * as IntegroUI from '@integro/ui';
import { connections } from './connections';
import * as components from './components';
import appConfig from './app.yaml';
import siteConfig from './config.yaml';
import * as scripts from './scripts';
import hu from './messages/hu.po';
import { pickRootComponent } from './layouts';

const application = new Application({
  ...appConfig,
  connections,
  config: siteConfig,
  translations: [hu],
  home: 'Dashboard',
} as unknown as ApplicationSpec);

const RootComponent = pickRootComponent(application.layout);
const vueApp = createApp(RootComponent);

vueApp.use(createPinia());
vueApp.use(IntegroUI);

Object.entries(components).forEach(([name, component]) => {
  if (component) {
    vueApp.component(name, component.default || component);
  }
});

application.install(vueApp);
scripts.initialize(application);

application.waitForReady().then(() => {
  vueApp.mount('#itp-app');
});
